module.exports = __webpack_public_path__ + "img/448-b83033.png";